import styled from "styled-components/macro"

const Spacer = styled.div`
	margin-right: auto;
`

export default Spacer
